module.exports = __webpack_public_path__ + "static/media/4.039a82c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/4.png
// module id = 940
// module chunks = 0